import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-10" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "财务审批详情", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("财务审批")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("添加共享票据")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("回退")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("锁定")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("解锁")
const _hoisted_9 = { class: "dialog-footer" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 费用类型： ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("添加票据")
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" % ")
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("取消添加")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("确认回退")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_ApprovalTable = _resolveComponent("ApprovalTable")!
  const _component_Invoice = _resolveComponent("Invoice")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ScanBarcode = _resolveComponent("ScanBarcode")!
  const _component_el_transfer = _resolveComponent("el-transfer")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createVNode(_component_el_divider),
    _createVNode(_component_el_button, {
      type: "info",
      icon: "back",
      class: "mb-10",
      onClick: _ctx.backPre
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_el_button, {
      type: "primary",
      class: "mb-10",
      onClick: _ctx.approvalProcess
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_el_button, {
      class: "mb-10",
      onClick: _ctx.addSpInvoiceList
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_ApprovalTable, {
      showApprovedRecordId: true,
      onEdit: _ctx.editTax,
      editText: '编辑发票',
      tableData: _ctx.historyDetailData,
      tableLoading: _ctx.tableLoading,
      onPageChange: _ctx.pageChange,
      totalNumber: _ctx.pageSetting.totalNum
    }, {
      back: _withCtx(({data}) => [
        _createVNode(_component_el_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_link, {
              disabled: data.locked==1,
              onClick: ($event: any) => (_ctx.backMethos(data))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 2
            }, 1032, ["disabled", "onClick"]),
            (data.locked==0)
              ? (_openBlock(), _createBlock(_component_el_link, {
                  key: 0,
                  onClick: ($event: any) => (_ctx.locakData(data,1))
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (data.locked==1)
              ? (_openBlock(), _createBlock(_component_el_link, {
                  key: 1,
                  onClick: ($event: any) => (_ctx.locakData(data,0))
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["onEdit", "tableData", "tableLoading", "onPageChange", "totalNumber"]),
    _createVNode(_component_el_dialog, {
      draggable: true,
      "destroy-on-close": true,
      "close-on-press-escape": false,
      "close-on-click-modal": false,
      "show-close": false,
      modelValue: _ctx.taxDialogVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.taxDialogVisible) = $event)),
      title: "编辑票据",
      width: "95%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_9, [
          _createVNode(_component_el_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeInvoiceDialog(false)))
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeInvoiceDialog(true)))
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Invoice, {
          invoiceTypeList: [
                { label: '普票', value: 'OR'},
                { label: '共用普票', value: 'SH_OR'},
                { label: '专票', value: 'SP'},
                { label: '共用专票', value: 'SH_SP'},
                { label: '无票', value: 'NO'},
                { label: '单据', value: 'BILL'},
                { label: '确认无票', value: 'CONFIRM_NO'},
                { label: '电子发票-普票', value: 'EI_OR'},
                { label: '电子发票-专票', value: 'EI_SP'},
            ],
          invoiceLoading: _ctx.invoiceLoading,
          onGetInvoiceTotalAmount: _ctx.getInvoiceTotalAmount,
          currentCoEstimateAmount: _ctx.currentCoEstimateAmount,
          onInvoiceNoEnterMethod: _ctx.invoiceNoEnterMethod,
          onAddInvoice: _ctx.addInvoice,
          invoiceData: _ctx.invoiceData,
          onDeleteInvoice: _ctx.deleteInvoice,
          onSaveInvoice: _ctx.saveInvoice,
          onTotalAmountChange: _ctx.totalAmountChange,
          onInvoiceTypeChange: _ctx.invoiceTypeChange
        }, null, 8, ["invoiceLoading", "onGetInvoiceTotalAmount", "currentCoEstimateAmount", "onInvoiceNoEnterMethod", "onAddInvoice", "invoiceData", "onDeleteInvoice", "onSaveInvoice", "onTotalAmountChange", "onInvoiceTypeChange"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.approvalDialogVisiable,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.approvalDialogVisiable) = $event)),
      title: "审批",
      draggable: ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.saveApproval
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _hoisted_12,
        _createVNode(_component_el_select, {
          modelValue: _ctx.expenseType,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.expenseType) = $event)),
          onChange: _ctx.approvalProcess,
          placeholder: "选择一项"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              value: "COST_REIMBURSE",
              label: "费用报销"
            }),
            _createVNode(_component_el_option, {
              value: "COST_APPLY",
              label: "用款申请"
            }),
            _createVNode(_component_el_option, {
              value: "COST_INTERNAL",
              label: "内部转账"
            }),
            _createVNode(_component_el_option, {
              value: "COST_RENT",
              label: "房租水电"
            }),
            _createVNode(_component_el_option, {
              value: "COST_SALARY",
              label: "薪酬发放"
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"]),
        _createVNode(_component_el_divider),
        _createVNode(_component_ScanBarcode, { onBarCode: _ctx.barCode }, null, 8, ["onBarCode"]),
        _withDirectives(_createVNode(_component_el_transfer, {
          modelValue: _ctx.approvalData,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.approvalData) = $event)),
          props: {
                key: 'id',
                label: 'desc',
            },
          data: _ctx.approvalList,
          filterable: "",
          "filter-method": _ctx.filterMethod,
          "target-order": "push"
        }, null, 8, ["modelValue", "data", "filter-method"]), [
          [_directive_loading, _ctx.approvalDataLoading]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      draggable: true,
      modelValue: _ctx.SpInvpiceVisible,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.SpInvpiceVisible) = $event)),
      title: "添加共享票据",
      width: "88%",
      loading: _ctx.delInvBtnFg
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          class: "mb-15",
          type: "primary",
          onClick: _ctx.addSpInvoice
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_table, {
          class: "tableBox",
          data: _ctx.SP_IncoiceData,
          align: "center",
          border: "",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "invoiceType",
              label: "类型"
            }, {
              default: _withCtx(({row}) => [
                (!row.isEdit)
                  ? (_openBlock(), _createBlock(_component_el_select, {
                      key: 0,
                      modelValue: row.invoiceType,
                      "onUpdate:modelValue": ($event: any) => ((row.invoiceType) = $event),
                      class: "m-2",
                      size: "default"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "共用普票",
                          value: "SH_OR"
                        }),
                        _createVNode(_component_el_option, {
                          label: "共用专票",
                          value: "SH_SP"
                        })
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.invoiceType(row.invoiceType)), 1))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "invoiceCode",
              label: "发票代码"
            }, {
              default: _withCtx(({row}) => [
                (!row.isEdit)
                  ? (_openBlock(), _createBlock(_component_el_input, {
                      key: 0,
                      modelValue: row.invoiceCode,
                      "onUpdate:modelValue": ($event: any) => ((row.invoiceCode) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(row.invoiceCode), 1))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "invoiceNo",
              label: "发票号码"
            }, {
              default: _withCtx(({row}) => [
                (!row.isEdit)
                  ? (_openBlock(), _createBlock(_component_el_input, {
                      key: 0,
                      modelValue: row.invoiceNo,
                      "onUpdate:modelValue": ($event: any) => ((row.invoiceNo) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(row.invoiceNo), 1))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "invoiceDate",
              label: "发票日期",
              width: "180px"
            }, {
              default: _withCtx(({row}) => [
                (!row.isEdit)
                  ? (_openBlock(), _createBlock(_component_el_date_picker, {
                      key: 0,
                      modelValue: row.invoiceDate,
                      "onUpdate:modelValue": ($event: any) => ((row.invoiceDate) = $event),
                      type: "date",
                      placeholder: "选择发票日期",
                      style: {"width":"100%"}
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.dayjs(row.invoiceDate).format('YYYY-MM-DD')), 1))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "totalAmount",
              label: "总金额"
            }, {
              default: _withCtx(({row}) => [
                (!row.isEdit)
                  ? (_openBlock(), _createBlock(_component_el_input, {
                      key: 0,
                      modelValue: row.totalAmount,
                      "onUpdate:modelValue": ($event: any) => ((row.totalAmount) = $event),
                      min: 0,
                      type: "number"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(row.totalAmount), 1))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "invoiceBalance",
              label: "余额"
            }, {
              default: _withCtx(({row}) => [
                _createElementVNode("span", null, _toDisplayString(row.invoiceBalance), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "taxRate",
              label: "税率(单位：%)"
            }, {
              default: _withCtx(({row}) => [
                (!row.isEdit)
                  ? (_openBlock(), _createBlock(_component_el_input, {
                      key: 0,
                      modelValue: row.taxRate,
                      "onUpdate:modelValue": ($event: any) => ((row.taxRate) = $event),
                      min: 0,
                      type: "number",
                      onChange: ($event: any) => (_ctx.totalAmountChange(row))
                    }, {
                      suffix: _withCtx(() => [
                        _hoisted_20
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(row.taxRate), 1))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "taxAmount",
              label: "税额"
            }, {
              default: _withCtx(({row}) => [
                (!row.isEdit)
                  ? (_openBlock(), _createBlock(_component_el_input, {
                      key: 0,
                      modelValue: row.taxAmount,
                      "onUpdate:modelValue": ($event: any) => ((row.taxAmount) = $event),
                      min: 0,
                      type: "number"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(row.taxAmount), 1))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "taxExcluded",
              label: "不含税"
            }, {
              default: _withCtx(({row}) => [
                (!row.isEdit)
                  ? (_openBlock(), _createBlock(_component_el_input, {
                      key: 0,
                      modelValue: row.taxExcluded,
                      "onUpdate:modelValue": ($event: any) => ((row.taxExcluded) = $event),
                      min: 0,
                      type: "number"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(row.taxExcluded), 1))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "note",
              label: "备注"
            }, {
              default: _withCtx(({row}) => [
                (!row.isEdit)
                  ? (_openBlock(), _createBlock(_component_el_input, {
                      key: 0,
                      modelValue: row.note,
                      "onUpdate:modelValue": ($event: any) => ((row.note) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(row.note), 1))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "ops",
              label: "操作",
              width: "180px"
            }, {
              default: _withCtx((scope) => [
                (scope.row.isEdit)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      size: "small",
                      onClick: ($event: any) => (scope.row.isEdit=false)
                    }, {
                      default: _withCtx(() => [
                        _hoisted_25
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      size: "small",
                      type: "primary",
                      disabled: scope.row.canClick,
                      loading: scope.row.canClick,
                      onClick: ($event: any) => (_ctx.saveSpInvoice(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_26
                      ]),
                      _: 2
                    }, 1032, ["disabled", "loading", "onClick"])),
                (!scope.row.id)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 2,
                      size: "small",
                      type: "danger",
                      plain: "",
                      onClick: ($event: any) => (_ctx.cancelInvalidInvoice(scope))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_27
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (scope.row.isEdit)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 3,
                      size: "small",
                      type: "danger",
                      onClick: ($event: any) => (_ctx.delInvalidInvoice(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_28
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue", "loading"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.backDialogVisiable,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.backDialogVisiable) = $event)),
      title: "回退原因",
      width: "500px",
      draggable: ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.backDialogVisiable = false))
        }, {
          default: _withCtx(() => [
            _hoisted_29
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "danger",
          onClick: _ctx.saveBackReason
        }, {
          default: _withCtx(() => [
            _hoisted_30
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: _ctx.backReason.reason,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.backReason.reason) = $event)),
          placeholder: "请输入回退原因",
          clearable: "",
          type: "textarea",
          rows: "6",
          style: {"width":"450px"}
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}